// React Imports
import React, { useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { IUserDocument } from "../../Models/IUserDocument";

import { baseUrl } from "../../helpers/constants";
import { IAcademyDocumentFolder } from "../../Models/IAcademyDocumentFolder";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";

// Props
interface IDeleteAcademyDocumentFolderDialogProps {
  isDialogOpen: boolean;
  academyFolder: IAcademyDocumentFolder | undefined;
  onDismiss: any;
  onDelete: any;
}

// Function
function DeleteAcademyDocumentFolderDialog(
  props: IDeleteAcademyDocumentFolderDialogProps,
) {
  const removeAcademyDocumentFolder = () => {
    if (props.academyFolder?.guid) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/academy/RemoveAcademyDocumentFolder?academyDocumentFolderGuid=${props.academyFolder?.guid}`,
        )
        .then(() => {
          props.onDelete();
        });
    }
  };

  return (
    <div>
      <Dialog open={props.isDialogOpen} onOpenChange={() => props.onDismiss()}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{i18n.t<string>("removeAcademyFolder")}</DialogTitle>
            <DialogContent>
              <div>
                {props.academyFolder
                  ? i18n
                      .t("removeAcademyFolderText")
                      .replace(
                        "{title}",
                        props.academyFolder.title
                          ? props.academyFolder.title
                          : "",
                      )
                  : ""}
              </div>
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button
                  onClick={() => {
                    props.onDismiss();
                  }}
                  appearance="secondary"
                >
                  {i18n.t<string>("cancel")}
                </Button>
              </DialogTrigger>
              <Button
                icon={<DeleteRegular />}
                onClick={() => {
                  removeAcademyDocumentFolder();
                }}
                appearance="primary"
              >
                {i18n.t<string>("delete")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

// Export Function
export default DeleteAcademyDocumentFolderDialog;
